if (DESKTOP) {
    var headerInnerWidth = $('#header-inner').outerWidth(true);
    var headerMiscWidth = $('#header-misc').outerWidth(true);
    var headerNavMaxWidth = headerInnerWidth - headerMiscWidth;

    var $headerNavItem = $('.js-header-nav-item');
    var $headerNavItemMore = $('#header-nav-item-more');
    var headerNavItemMoreWidth = $headerNavItemMore.outerWidth(true);

    var headerNavItemArray = [];
    var headerNavItemsWidth = headerNavItemMoreWidth + 30;

    for (var i = 0; i < $headerNavItem.length; i++) {
        headerNavItemArray.push($headerNavItem[i]);
        headerNavItemsWidth += parseInt($(headerNavItemArray[i]).outerWidth(true));
        if (headerNavItemsWidth > headerNavMaxWidth) {
            $headerNavItemMore.css('visibility', 'visible');
            $('.js-header-nav-item:nth-child(n+' + (i + 1) + ')').css('display', 'none');
            $('.js-header-nav-popup-item:nth-child(-n+' + (i - 1) + ')').css('display', 'none');
            break;
        }
    }

    // Show menu
    $('#header-menu').css('opacity', '1');
}

if (MOBILE) {
    $('.js-header-nav-item').filter(function() {
        return $(this).find('.header-nav__item--sub-list').length > 0;
    }).on('click touchstart', function(e){
        if ( $(e.target).closest('.header-nav__item--sub-list').length == 0) {
            $(this).find('.header-nav__item--sub-list').slideToggle(350);
            return false
        }
    });
}